import translation from "./translation.json";
export const TRANSLATIONS_ARAB = translation
 
